export default {
  created() {
    if (!this.user) {
      this.$router.push(this.i18nLink('login'));
    }
  },
};
